import React from 'react';
import { FileText, CheckCircle, Palette, Upload, Rocket, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const Methodology = () => {
  const steps = [
    {
      number: 1,
      icon: FileText,
      title: 'Entrega del manuscrito',
      description: 'Nos pasás tu documento completo (Word, PDF o similar) con la redacción final.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      number: 2,
      icon: CheckCircle,
      title: 'Revisión profesional',
      description: 'Revisamos juntos: corregimos ortografía, gramática, flujo y detalles para que quede impecable y profesional.',
      color: 'from-green-500 to-green-600'
    },
    {
      number: 3,
      icon: Palette,
      title: 'Diseño editorial',
      description: 'Diseñamos la portada y el interior (físico o digital) con estética cuidada y coherente con tu mensaje.',
      color: 'from-purple-500 to-purple-600'
    },
    {
      number: 4,
      icon: Upload,
      title: 'Publicación',
      description: 'Una vez pulido todo, lo preparamos para publicación: subimos a plataformas digitales (Amazon KDP y otras) para que esté disponible en todo el mundo.',
      color: 'from-amber-500 to-amber-600'
    },
    {
      number: 5,
      icon: Rocket,
      title: 'Lanzamiento',
      description: 'Te acompañamos en el lanzamiento y promoción básica si querés.',
      color: 'from-red-500 to-red-600'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="font-serif text-5xl md:text-6xl font-bold text-gray-900 mb-4">
              Cómo trabajamos
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-600 to-amber-800 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Un proceso claro, transparente y diseñado para que tu libro llegue con el impacto que merece
            </p>
          </div>

          {/* Steps */}
          <div className="space-y-8 mb-12">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <Card key={index} className="shadow-lg border-gray-200 hover:shadow-xl transition-shadow duration-300">
                  <CardContent className="p-6 md:p-8">
                    <div className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6">
                      {/* Step Number & Icon */}
                      <div className="flex items-center space-x-4 flex-shrink-0">
                        <div className={`w-16 h-16 bg-gradient-to-br ${step.color} rounded-full flex items-center justify-center text-white font-bold text-2xl shadow-lg`}>
                          {step.number}
                        </div>
                        <div className="bg-gray-100 p-3 rounded-full hidden md:block">
                          <Icon className="text-gray-700" size={28} />
                        </div>
                      </div>

                      {/* Content */}
                      <div className="flex-1">
                        <h3 className="text-2xl font-serif font-bold text-gray-900 mb-2">
                          {step.title}
                        </h3>
                        <p className="text-gray-600 leading-relaxed">
                          {step.description}
                        </p>
                      </div>

                      {/* Arrow (desktop only) */}
                      {index < steps.length - 1 && (
                        <div className="hidden md:block">
                          <ArrowRight className="text-gray-400" size={24} />
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {/* Closing Statement */}
          <Card className="bg-gradient-to-br from-amber-50 to-white border-amber-200 shadow-xl">
            <CardContent className="p-8 md:p-12 text-center">
              <p className="text-2xl font-serif text-gray-800 leading-relaxed">
                Sin promesas vacías: <span className="font-bold text-amber-700">calidad real</span>, proceso <span className="font-bold text-amber-700">transparente</span> y foco en que tu libro llegue con <span className="font-bold text-amber-700">impacto</span>.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};